import { writable } from 'svelte/store';

const act = writable({
    id: null,
    action: null
});

export const action = {
    subscribe: act.subscribe,
    set: act.set,
    clear: () => {
        act.set({
            id: null,
            action: null
        });
    }
}

const actsel = writable({
    id: null,
    action: null
});

export const selectedAction = {
    subscribe: actsel.subscribe,
    set: actsel.set,
    clear: () => {
        actsel.set({
            id: null,
            action: null
        });
    }
}

const acts = writable([]);

export const actions = {
    subscribe: acts.subscribe,
    set: acts.set,
    clear: () => {
        acts.set([]);
    }
}


